<template>
    <div>
      <div class="col-md-3 col-xs-12">
        <va-small-box
          class="info-box box-yellow"
          icon="ion-chatbubbles "
          :title="message[5].interest[1].totalInterestCr"
          description="Total Interest">
        </va-small-box>
      </div>
    </div>
</template>
<script>
import VASmallBox from '../widgets/VASmallBox.vue'
export default {
  name: 'my-component',
  props: ['message'],
  data () {
    return {
      smsbal: 0
    }
  },
  methods: {
  },
  components: {
    'va-small-box': VASmallBox
  }
}
</script>
<style>
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .box-yellow {
    background-color: #a300ff;
    color: #fff;
  }
  .iconColor {
    color: rgb(12, 156, 55);
  }
  /* .small-box > .small-box-footer {
  background: rgb(12, 156, 55);
} */
</style>




// WEBPACK FOOTER //
// interestbalance.vue?f1c2a95e